import { AccountScoreGenerationLogState } from './account-score-generation-log-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import { Action, StateStatus, updateStatus } from '../reducers/utils/state-manager';

const InitialState = {
  recentAccountScoreGenerationLog: null,
  recentAccountScoreGenerationLogStatus: StateStatus.notAttempted,
};

export const accountScoreGenerationLogReducer = (
  state: AccountScoreGenerationLogState = InitialState,
  action: Action,
) => {
  switch (action.type) {
    case STARTING('LOAD_RECENT_ACCOUNT_SCORE_GENERATION_LOG'): {
      return updateStatus(state, 'recentAccountScoreGenerationLog', true);
    }
    case SUCCESS('LOAD_RECENT_ACCOUNT_SCORE_GENERATION_LOG'): {
      const { data }: { data: AccountScoreGenerationLog } = action.payload;
      return updateStatus(state, 'recentAccountScoreGenerationLog', false, data);
    }
    case FAILURE('LOAD_RECENT_ACCOUNT_SCORE_GENERATION_LOG'): {
      return updateStatus(state, 'recentAccountScoreGenerationLog', false);
    }
    default: {
      return state;
    }
  }
};
